export const ActionType = {
  SET_FLAG: 'SET_FLAG',
  SET_THEME_FLAG: 'SET_THEME_FLAG',
}
